import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { MaskLines } from "../components/site/Reveal";

export default function OrderConfirmed() {
  const { number } = useParams();
  return (
    <div className="grid min-h-[90vh] place-items-center bg-ivory px-5 pt-32 text-center" data-testid="order-confirmed-page">
      <div className="max-w-xl">
        <motion.img src="/img/emblem.png" alt="" initial={{ rotateY: 180, opacity: 0 }} animate={{ rotateY: 0, opacity: 1 }} transition={{ duration: 1.2 }} className="mx-auto h-24 w-24" />
        <p className="label-mono mt-8">Order confirmed</p>
        <MaskLines as="h1" lines={["Thank you.", <em key="t">Move freely.</em>]} className="mt-3 font-display text-5xl font-light leading-[0.95] text-ink md:text-6xl" />
        <p className="mt-6 text-sm text-graphite">Your order number is <span className="font-mono text-ink" data-testid="order-number">{number}</span>. Keep it to track your delivery.</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/track-order" className="btn-dark" data-testid="order-track-button">Track order</Link>
          <Link to="/shop" className="btn-outline" data-testid="order-continue-button">Continue shopping</Link>
        </div>
      </div>
    </div>
  );
}
